import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://your-project.supabase.co'
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'your-anon-key'

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

// Database table names
export const TABLES = {
  ARTICLES: 'articles',
  COMMENTS: 'comments',
  PROFILES: 'profiles'
}

// Storage bucket names
export const BUCKETS = {
  ARTICLE_IMAGES: 'article-images'
}